import MonetaryFormatter from "~/app/helper/MonetaryFormatter";
import Vue from "vue";

Vue.filter("currencyPlenty", function(price, currency = App.activeCurrency)
{
    const formatter = new MonetaryFormatter();

    //set default formatting of system so my-account prices are formatted same
    if(App.language === 'de') {
        formatter.setPattern('#,##0.00 ¤')
        formatter.setSeparators('.', ',');
    }else {
        formatter.setPattern('¤ #,##0.00');
        formatter.setSeparators(',', '.');
    }

    if (price === "N / A") {
        return price;
    }

    return formatter.format(parseFloat(price), currency);
});
